module.exports = __webpack_public_path__ + "img/hero1.e738ef7d.jpg";